import { client } from "./client";
import interceptors from "./interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getRetur(params) {
	return client.get("api/por/data", {
		params: params,
	});
}

function getOptionStatusRetur() {
	return client.get("api/options/retur-status");
}

function getOptionReturforApprove() {
	return client.get("api/options/retur-to-approve");
}

function exportRetur(params) {
	return client.get("api/por/export", {
		params: params,
	});
}

function detailRetur(params) {
	return client.get("api/por/detail", {
		params: {
			por_code : params
		},
	});
}

function createRetur(params) {
	return client.post("api/por/create", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function approveRetur(params) {
	return client.post("api/por/approve", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function rejectRetur(params) {
	return client.post("api/por/reject", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	getRetur,
	getOptionStatusRetur,
	getOptionReturforApprove,
	exportRetur,
	detailRetur,
	createRetur,
	approveRetur,
	rejectRetur,
};